import { oids } from "@/configs/Settings";
import { GetOrganizations } from "@/services/fhir";
import { useFormatter } from "@/utils/useFormatter";

const UNKNOWN_ORGANIZATION = "Organização não identificada";

/** `Organization/<oid>-<cnpj>` → `<oid>-<cnpj>`. */
export function organizationIdFromReference(reference?: string): string {
  if (!reference?.startsWith("Organization/")) return "";
  return reference.split("/")[1] || "";
}

/** Fallback quando não dá para ler a Organization (ex.: sem permissão). */
function fallbackDisplay(organizationId: string): string {
  const cnpj = organizationId.replace(`${oids.cnpj}-`, "");
  return cnpj ? `CNPJ ${useFormatter.formatCNPJ(cnpj)}` : UNKNOWN_ORGANIZATION;
}

/**
 * Nome de cada organização, uma chamada por id único.
 * Falha de leitura vira fallback; nunca rejeita.
 */
export async function resolveOrganizationDisplays(
  organizationIds: string[],
): Promise<Map<string, string>> {
  const uniqueIds = [...new Set(organizationIds.filter(Boolean))];
  const results = await Promise.allSettled(
    uniqueIds.map((id) => GetOrganizations({ orgIds: id })),
  );

  const displays = new Map<string, string>();
  uniqueIds.forEach((id, index) => {
    const result = results[index];
    const name =
      result.status === "fulfilled"
        ? (result.value as fhir5.Organization | undefined)?.name
        : undefined;
    displays.set(id, name || fallbackDisplay(id));
  });
  return displays;
}

export { UNKNOWN_ORGANIZATION };
